import { ApiService } from "./api.service";
export default class CalendarService extends ApiService {
  namespace = "calendar";
  icon = "Calendar";
  favicon = "Calendar";
  window = 290;
  Width = 850;
  action = "action";
  enableSchedular = true;
  constructor() {
    super("calendars");
  }
  getEvents() {
    return fetch("data/events.json")
      .then((res) => res.json())
      .then((d) => d.data);
  }
}
